import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environments/environment';

@Injectable()
export class AuthenticationService {

  private authenticationServer = environment.authenticationServer;
  expires: string;
  issued: string;
  access_token: string;
  client_id: string;
  expires_in: number;
  refresh_token: string;
  token_type: string;
  userName: string;

  constructor(private _http: HttpClient) {  }

  login(username: string, password: string): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
    const options = {
      headers: headers
    };
    const body =
      'grant_type=password' +
      '&client_id=agentAuthApp' +
      '&username=' + encodeURIComponent(username) +
      '&password=' + encodeURIComponent(password) +
      '&remember=true';

    return this._http.post<any>(this.authenticationServer + 'auth/login', body, options);
  }

  logout(): Observable<any> {
    const headersOptions = {};
    headersOptions['Authorization'] = 'Bearer ' + this.access_token;

    const headers = new HttpHeaders(headersOptions);
    const options = {
      headers: headers
    };

    return this._http.get<any>(this.authenticationServer + 'auth/logout', options);
  }

  isEmailFree(email: string): Observable<any> {
    const headersOptions = {};
    headersOptions['Authorization'] = 'Bearer ' + this.access_token;

    const headers = new HttpHeaders(headersOptions);
    const options = {
      headers: headers
    };

    return this._http.get<any>(this.authenticationServer + 'auth/isEmailFree?email=' + email, options);
  }

  loadFromWSResponse(res: any) {
    this.expires = res['.expires'];
    this.issued = res['.issued'];
    this.access_token = res['access_token'];
    this.client_id = res['as:client_id'];
    this.expires_in = res['expires_in'];
    this.refresh_token = res['refresh_token'];
    this.token_type = res['token_type'];
    this.userName = res['userName'];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/api/authentication/authentication.service.ts